/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../../utils/apiClient';
import { restructureUserOutputAccountsModel } from './restructuring';

class UserOutputAccountsService {
  async getAuthUserOutputAccounts(state) {
    const response = await api.get('/payout/user-accounts/get-me', {});
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        itemsById: _.keyBy(
          _.map(responseJson.data, item =>
            restructureUserOutputAccountsModel(state, item)
          ),
          'id'
        ),
        itemsIds: _.map(responseJson.data, item => item.id)
      }
    };
  }

  async saveAuthUserOutputAccount(state, body) {
    const response = await api.post(
      '/payout/user-accounts/edit-me',
      {},
      { body }
    );
    const responseJson = await response.json();
    return responseJson;
  }
}

export default new UserOutputAccountsService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/authUserOutputCash/services/UserOutputAccountsService/UserOutputAccountsService.js